module.exports = __webpack_public_path__ + "static/media/b1_p7_scout.800ad9de.mp3";